export default function IntroductionStittsvilleLocal() {
  return <section data-section-id="259552" id="introduction-stittsville-local" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="mx-auto max-w-3xl">
          <h2 className="font-default mb-10 text-center text-3xl font-bold text-foreground md:text-4xl">
            Our{" "}
            <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Roots
            </span>
          </h2>

          <div className="space-y-6 text-base leading-relaxed text-muted-foreground md:text-lg">
            <p>
              Stittsville Local began with a simple observation in our own backyard. 
              Living in the heart of Stittsville, we saw incredible local businesses 
              from Carp to North Gower struggling to compete with big-box retailers 
              simply because they weren't visible where it mattered most: online.
            </p>

            <p>
              We realized that our neighbors in Kanata and Nepean were looking for 
              the unique services our local artisans and tradespeople provide, but 
              the digital gap was too wide.{" "}
              <span className="font-medium text-primary">
                We decided to bridge that gap.
              </span>{" "}
              By focusing on hyper-local SEO and community-driven storytelling, we 
              turned quiet storefronts into bustling community hubs.
            </p>

            <p>
              Our mission is clear:{" "}
              <span className="font-medium text-secondary">
                empower the heartbeat of our community
              </span>{" "}
              by giving small business owners the digital tools they need to thrive 
              without the complexity of traditional marketing agencies.
            </p>

            <p>
              Today, Stittsville Local is more than a service provider; we are your 
              neighbors and growth partners. Whether you are a boutique in Carp or 
              a contractor in North Gower, we are dedicated to ensuring your 
              business is the first one your neighbors find.
            </p>
          </div>
        </div>
      </div>
    </section>;
}